import { render, staticRenderFns } from "./SpellcheckerPanelPostTitle.vue?vue&type=template&id=8c520914"
import script from "./SpellcheckerPanelPostTitle.vue?vue&type=script&lang=js"
export * from "./SpellcheckerPanelPostTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports